import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import EmptyMappingIcon from '@/assets/icons/empty-mapping.svg';
import PlusSm from '@/assets/icons/plus-sm.svg';
import { HiringGoalModal } from '@/components/pages/channels/hiring-goals-modal';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import {
  useOpeningContext,
  useOpeningDetails,
} from '@/contexts/opening-context';
import { RotateCcw } from 'lucide-react';
import { CalendarIcon } from '@/components/icons/calendar';
import { LIFETIME } from '@/components/ui/date-range-picker';

export function HiringGoalEmptyState() {
  const intl = useIntl();
  const {
    hiringGoalEditUrl,
    opening: { defaultMetricsPeriod },
  } = useOpeningDetails();
  const { setMetricsViewMode } = useOpeningContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="border-fx-neutral-200 flex h-full max-h-full flex-1 flex-col items-center justify-center overflow-hidden rounded-lg border bg-white pb-8">
        <EmptyState
          className="!flex-none"
          icon={EmptyMappingIcon}
          header={intl.formatMessage({
            defaultMessage: 'Set a hiring goal to track pacing',
            description:
              'Empty state title when the opening has no active hiring goal on the channels tab',
          })}
          description={intl.formatMessage({
            defaultMessage:
              'Add a target hire count and date — Source will pace your campaigns and flag risks before you fall behind.',
            description:
              'Empty state description when the opening has no active hiring goal on the channels tab',
          })}
          buttonTitle={intl.formatMessage({
            defaultMessage: '+ Add hiring goal',
            description: 'Button to open hiring goal creation page',
          })}
          onClick={() => window.open(hiringGoalEditUrl, '_blank')}
        />
        <div className="flex flex-wrap items-center justify-center gap-2 pt-3">
          <Button variant="ghost" onClick={() => setIsModalOpen(true)}>
            <RotateCcw className="!h-4 !w-4" />
            <FormattedMessage
              defaultMessage="View past goals"
              description="Button to view past hiring goals in modal"
            />
          </Button>
          <div className="bg-fx-neutral-200 w-px self-stretch" aria-hidden />
          <Button
            variant="ghost"
            onClick={() =>
              setMetricsViewMode('date_range', defaultMetricsPeriod ?? LIFETIME)
            }
          >
            <CalendarIcon className="!h-4 !w-4" />
            <FormattedMessage
              defaultMessage="View by date range"
              description="Button to switch metrics view to date range tab"
            />
          </Button>
        </div>
      </div>

      <HiringGoalModal open={isModalOpen} onOpenChange={setIsModalOpen} />
    </>
  );
}
